<template>
  <div class="card">
    <div class="card-title">接口 / 部署指引</div>
    <ul class="doc-list">
      <li>POST /api/image —— 豆包 Seedream 生图；接受 image(URL/data URI/纯 base64)；需要 API Key。</li>
      <li>POST /api/remove-bg —— mode=backgroundremover（本地命令）或 mode=doubao（豆包抠图+背景重绘）。</li>
      <li>POST /api/fission —— 基于底图与商品图做裂变融合；支持多参考图输入；需要 API Key。</li>
      <li>
        环境变量 BACKGROUNDREMOVER_CMD 可指定命令路径，如：<code>~/venv/bin/backgroundremover</code>
        或 <code>python -m backgroundremover</code>。
      </li>
    </ul>

    <div class="card-title small">在 venv 中安装 backgroundremover</div>
    <pre class="code">python3 -m venv venv
source venv/bin/activate
pip install backgroundremover
# 运行前设置
export BACKGROUNDREMOVER_CMD="$(pwd)/venv/bin/backgroundremover"</pre>
  </div>
</template>
